// Eligibility comes from Hub, scoped to the customer's decision flow.
export const canResumeHumanAttention = (conversation, now = Date.now()) => Boolean(
    conversation?.decision_flow_managed && conversation.mode === 'bot_active' &&
    !conversation.bot_return_pending && conversation.service_window_until &&
    new Date(conversation.service_window_until).getTime() > now
);

export const getManagedReadOnlyMessage = (conversation, now = Date.now()) => {
    if (conversation?.bot_return_pending) return 'Devolución al bot pendiente. Solo lectura.';
    if (conversation?.status === 'closed') return 'Conversación cerrada. Solo lectura.';
    if (conversation?.mode === 'bot_active') return 'Conversación gestionada por el bot. Solo lectura.';
    if (!conversation?.service_window_until) return 'Esperando respuesta del cliente. Solo lectura.';
    if (new Date(conversation.service_window_until).getTime() <= now) {
        return 'La ventana de atención de 24 horas ha caducado. Solo lectura.';
    }
    return 'La conversación no está disponible para atención. Actualiza la bandeja.';
};

export const isManagedReadOnly = (conversation, now = Date.now()) => {
    if (!conversation?.decision_flow_managed) return false;
    return conversation.mode !== 'human_active' || conversation.status === 'closed' ||
        conversation.can_operate === false || conversation.bot_return_pending ||
        (!conversation.human_attention_pending && (!conversation.service_window_until || new Date(conversation.service_window_until).getTime() <= now));
};

export const isManagedBotHidden = (conversation, now = Date.now()) => {
    if (!conversation?.decision_flow_managed) return false;
    return conversation.mode !== 'human_active' || conversation.status === 'closed' ||
        (!conversation.human_attention_pending && (!conversation.service_window_until || new Date(conversation.service_window_until).getTime() <= now));
};
